import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import useFetchMemberInfo from 'hooks/useMemberInfo';
import { SignOut } from 'components/RewardProgramSignOut';
import useHyattAuth from 'hooks/useHyattAuth';

const TertiaryText = styled.span`
  color: var(--way-colors-tertiaryTextColor);
`;

const HyattSignOut = () => {
  const { t: translate } = useTranslation();
  const { handleSignOut } = useHyattAuth();

  const [memberInfo, setMemberInfo] = React.useState<{
    name: string | undefined;
    points: string | undefined;
  }>({
    name: '',
    points: '',
  });

  const signOutOptions = [
    { label: translate('signOut'), value: 'signout', action: handleSignOut },
  ];

  useFetchMemberInfo({
    onSuccess: (memberData) => {
      setMemberInfo({
        name: memberData.firstName,
        points: memberData.points,
      });
    },
    onError: (error) => {
      console.error('Error fetching member info:', error);
    },
  });

  if (!memberInfo.points) return null;

  return (
    <SignOut signOutOptions={signOutOptions}>
      <>
        <span>{memberInfo.name}</span>
        <TertiaryText>
          {translate('pointsWithCount', { count: Number(memberInfo.points) })}
        </TertiaryText>
      </>
    </SignOut>
  );
};

export default HyattSignOut;
